import { SERVICE_JOB_DETAIL_COLUMN_IDS, type ServiceJobDetailColumnId } from '@cabgo/shared';

export interface ReportColumnDefinition {
  id: ServiceJobDetailColumnId;
  width: number;
  sort?: 'tripRef' | 'status' | 'serviceDate' | 'createdAt';
}

const SORT_BY_COLUMN: Partial<Record<ServiceJobDetailColumnId, ReportColumnDefinition['sort']>> = {
  trip_ref: 'tripRef',
  trip_status: 'status',
  service_date: 'serviceDate',
  created_at: 'createdAt',
};

const WIDE_COLUMNS = new Set<ServiceJobDetailColumnId>([
  'passenger_name',
  'agent_name',
  'provider_name',
  'service_area_ids',
  'service_area_names',
  'service_group_name',
  'origin_label',
  'destination_label',
]);

export const SERVICE_JOB_DETAIL_COLUMNS: readonly ReportColumnDefinition[] =
  SERVICE_JOB_DETAIL_COLUMN_IDS.map((id) => ({
    id,
    width: WIDE_COLUMNS.has(id) ? 190 : 145,
    sort: SORT_BY_COLUMN[id],
  }));
